import React, { type JSX } from 'react';
import { useLocation } from 'react-router-dom';
import { List } from '@mui/material';

import { SidebarItemsType } from '../../types/sidebar';
import reduceChildRoutes from './reduceChildRoutes';

type SidebarNavListProps = {
  depth: number;
  pages: SidebarItemsType[];
};

const SidebarNavList: React.FC<SidebarNavListProps> = (props) => {
  const { pages, depth } = props;
  const router = useLocation();
  const currentRoute = router.pathname;

  const childRoutes = pages.reduce(
    (items, page) => reduceChildRoutes({ items, page, currentRoute, depth }),
    [] as JSX.Element[]
  );

  // For nested lists (depth > 0), wrap in a List component
  if (depth > 0) {
    return (
      <List 
        disablePadding 
        sx={{ pl: 2 }}
        aria-label="Submenu"
      >
        {childRoutes}
      </List>
    );
  }

  // For top-level items, return as fragment since they're already in a List
  return <React.Fragment>{childRoutes}</React.Fragment>;
};

export default SidebarNavList;
